var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaximize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75,18.189L4.75,16C4.75,15.586 4.414,15.25 4,15.25C3.586,15.25 3.25,15.586 3.25,16L3.25,20C3.25,20.128 3.282,20.248 3.339,20.354C3.366,20.404 3.399,20.453 3.439,20.497L3.457,20.517L3.47,20.53L3.491,20.55L3.503,20.561C3.547,20.601 3.595,20.634 3.646,20.661C3.752,20.718 3.872,20.75 4,20.75L8,20.75C8.414,20.75 8.75,20.414 8.75,20C8.75,19.586 8.414,19.25 8,19.25L5.811,19.25L10.53,14.53C10.823,14.238 10.823,13.762 10.53,13.47C10.238,13.177 9.762,13.177 9.47,13.47L4.75,18.189ZM18.189,4.75L13.47,9.47C13.177,9.762 13.177,10.238 13.47,10.53C13.762,10.823 14.238,10.823 14.53,10.53L19.25,5.811L19.25,8C19.25,8.414 19.586,8.75 20,8.75C20.414,8.75 20.75,8.414 20.75,8L20.75,4C20.75,3.872 20.718,3.752 20.661,3.646C20.634,3.596 20.601,3.547 20.561,3.503L20.543,3.483L20.53,3.47L20.509,3.45L20.497,3.439C20.453,3.399 20.405,3.366 20.354,3.339C20.248,3.282 20.128,3.25 20,3.25L16,3.25C15.586,3.25 15.25,3.586 15.25,4C15.25,4.414 15.586,4.75 16,4.75L18.189,4.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.1ae80c6d.svg";
export { ForwardRef as ReactComponent };